<template>
  <div class="focused-panel">
    <div class="d-flex valve-toolbar">
      <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create VALVE" :pressed.sync="addEnabled" variant="primary">
        <icon scale=".6" name="plus"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select VALVE" :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>


      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit VALVE geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled"
             variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit VALVE attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled"
             variant="primary">
        <icon scale=".6" name="pencil-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete VALVE" :disabled="!wellFeatureSelected"
             variant="primary">
        <icon scale=".6" name="times"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :pressed.sync="ldEnabled" v-b-tooltip.hover.auto title="Load dependant layers"
             variant="primary">
        <icon scale=".6" name="link"/>
      </b-btn>

    </div>

    <b-modal v-model="showForm">
      <div slot="modal-header">
        <label>{{formTitle}}</label>
        <div v-if='editablePhase'>
          <div v-if="!featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Lock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
            <span v-if='hoverLock' @click='setLockState(true)'><icon scale=".8" name="lock"/></span>
            <span v-if="!hoverLock"><icon scale=".8" name="unlock"/></span>
          </div>

          <div v-if="featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Unlock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
            <span v-if='hoverLock' @click='setLockState(false)'><icon scale=".8" name="unlock"/></span>
            <span v-if="!hoverLock"><icon scale=".8" name="lock"/></span>
          </div>
        </div>
      </div>
      <div class="p-2">
        <div id='feature-locked-warning' v-if="!editablePhase">
          <b-alert class='user-reminder' variant="warning" show>This feature is locked. It cannot be edited in this Area of responsibility</b-alert>
        </div>
        <div id='feature-locked-warning' v-if="editablePhase && featureLock">
          <b-alert class='user-reminder' variant="warning" show>This feature is locked. Click the unlock button in the upper right to edit feature</b-alert>
        </div>
        <b-form>
          <b-row>
              <b-col>
                <b-form-group label="Ident:" label-for="valve-Ident">
                  <b-form-input :state="identState" id="valve-Ident" :disabled="featureLock" v-model="wellAttrs['ident']" placeholder="Enter Valve ident"></b-form-input>
                  <b-form-invalid-feedback>
                    Well ident is not unique, change will be ignored
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
          </b-row>
          <b-row>
              <b-col>
                <b-form-group label="Type:" label-for="valve-type-select" class="valve-type-select">
                    <b-form-select :options="valveTypeOptions" id="valve-type-select" :disabled="featureLock" v-model="valveType" placeholder="Please, select option"></b-form-select>
                </b-form-group>
              </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label-for="valve-type-segregate">
                  <b-form-checkbox :unchecked-value="false" :value="true" v-model="wellAttrs['segregation_valve']" size="sm">Segregation valve</b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label-for="valve-closed">
                  <b-form-checkbox :unchecked-value="false" :value="true" v-model="wellAttrs['valve_closed']" size="sm">Valve closed</b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
              <b-col>
                <b-form-group label="Comment:" label-for="valve-comment">
                  <b-textarea id="valve-comment" :disabled="featureLock" v-model="wellAttrs['comment']" placeholder="Enter Valve comment" rows="3"></b-textarea>
                </b-form-group>
              </b-col>
          </b-row>
        </b-form>
      </div>
      <div slot="modal-footer" class="designatron-modal-footer">
        <b-row>
          <b-col>
            <div role="group" class="btn-group">
              <b-btn size="sm" class="float-right" variant="primary" @click="close">
                Close
              </b-btn>
              <b-btn size="sm" :disabled="featureLock" class="float-right" variant="success" @click="onOK">
                Save
              </b-btn>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>


  </div>
</template>

<script>

  import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'

  export default {
    name: 'valve-editor',
    components: {},
    mixins: [FeatureEditorMixin],
    data () {
      return {
        geomType: 'Point',
        wellLayerName: 'v4:valve',
        valveTypeOptions: [],
        valveType: '',
        wellAttrs: {
          ident: '',
          comment: '',
          segregation_valve: false,
          valve_closed: false
        },
        schema: 'valve',
        hoverLock: false,
        lockable: true,
        identState: null,
        initialIdent: null
      }
    },
    methods: {
      loadValveOptions () {
        this.$http.get('/api/layers/valve-type-options').then(res => {
          let fil = res.body.filter(f => f.subject)
          this.valveTypeOptions = fil.map(m => {
            return {
              text: m.subject,
              value: m.id
            }
          })
          this.valveTypeOptions = this.valveTypeOptions.concat({
            text: 'None',
            value: 0
          })
          if (this.wellFeature.get('station_data_id')) {
              this.valveType = this.wellFeature.get('station_data_id')
          } else {
              this.valveType = 0
          }

        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not load valve types',
            type: 'error'
          })
        })
      },
      close(evt) {
        this.showForm = false
        this.onCancel()
      },
    },
    watch: {
      showForm (val) {
        if (this.valveTypeOptions.length === 0) {
          this.loadValveOptions()
        }
      },
      valveType(val) {
        if (val) {
          this.wellFeature.set('station_data_id', val)
        }
      },
      wellAttrs: {
        handler(val) {
          if (!this.initialIdent) {
            this.initialIdent = val.ident
          }
          else if (this.initialIdent !== val.ident) {
            let me = this
            this.validateIdent(val.ident)
          } else {
            this.identState = null
          }
        },
        deep: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/ValveEditor.vue